<template>
  <div class="waybillDetail">
    <div class="title">
      高级货源运单 <span>添加邮箱地址</span>
    </div>
    <div class="orderview_title">
      运单信息
      <span>运单号：{{waybillNum}}</span>
    </div>
    <el-table style="width: 100%"
              :data="orderView"
              class="order_table">
      <el-table-column header-align="left"
                       align="left"
                       label="货源信息"
                       min-width="337px">
        <template slot-scope="scope">
          <div class="sourceInfo">
            <div class="orderList">
              <div>货源编号：</div>
              {{scope.row.goodsNum}}
            </div>
            <div class="orderList">
              <span>公司名称：</span>
              {{scope.row.companyName}}
            </div>
            <div class="orderList">
              <span>联系人姓名：</span>
              {{scope.row.companyLinkman}}
            </div>
            <div class="orderList">
              <span>联系电话：</span>
              {{scope.row.companyIphone}}
            </div>
            <div class="orderList">
              <span>货源有效期：</span>
              {{scope.row.startTimestr}}至{{scope.row.endTimestr}}
            </div>
          </div>
          <div class="logistics">
            <div class="orderList">
              <span>出发地：</span>
              {{scope.row.departLand}}{{scope.row.departLandDetails}}
            </div>
            <div class="orderList">
              <span>目的地：</span>
              {{scope.row.destina}}{{scope.row.destinaDetails}}
            </div>
            <div class="orderList">
              <span>期望运费：</span>
              {{scope.row.expectFreight}} 元/吨
            </div>
            <div class="orderList">
              <span>炼厂名称：</span>
              {{scope.row.refineryName}}
            </div>
            <div class="orderList">
              <span>原料：</span>
              {{scope.row.material}}
            </div>
            <div class="orderList">
              <span>重量：</span>
              {{scope.row.totalWeight}} 吨
            </div>
            <div class="orderList">
              <span>罐体：</span>
              <p v-if="scope.row.tankBody === '0'">铝罐</p>
              <p v-if="scope.row.tankBody === '1'">铁罐</p>
              <p v-if="scope.row.tankBody === '2'">白钢罐</p>
              <p v-if="scope.row.tankBody === '3'">铝合金罐</p>
              <p v-if="scope.row.tankBody === '4'">其他</p>
            </div>

          </div>
        </template>
      </el-table-column>
      <el-table-column header-align="left"
                       label="车源信息及服务费"
                       align="left"
                       class-name="order_car"
                       min-width="207px">
        <template slot-scope="scope">
          <el-row>
            <el-col :span="16">
              <div>
                <span>公司名称：</span>
                {{scope.row.userCompanyName}}
              </div>
              <div>
                <span>联系人姓名：</span>
                {{scope.row.userCompanyLinkman}}
              </div>
              <div>
                <span>联系电话：</span>
                {{scope.row.userCompanyIphone}}
              </div>
              <div>
                <span>车辆总数：</span>
                {{scope.row.vehicleNum}} 辆
              </div>
              <div>
                <span>总核载量：</span>
                {{scope.row.orderWeight}} 吨
              </div>
            </el-col>

            <el-col :span="8">
              <div v-if="scope.row.roleType==='0'">
                无服务费信息
              </div>
              <div v-else-if="scope.row.roleType==='1'|scope.row.roleType==='3'">
                <div v-if="scope.row.payType==='0'">
                  <span>付款方：</span>
                  物流公司
                </div>
                <div v-if="scope.row.payType==='1'">
                  <span>付款方：</span>
                  司机
                </div>
                <div v-if="scope.row.payType==='2'">
                  <span>付款方：</span>
                  未选择支付方式
                </div>
                <div>
                  <span>已支付：</span>
                  {{scope.row.payyessum}}元
                </div>
                <div>
                  <span>待支付：</span>
                  {{scope.row.paynosum}}元
                </div>
                <div>
                  <span>已支付车辆数：</span>
                  {{scope.row.payyesnum}}辆
                </div>
                <div v-if="scope.row.payState==='0'">
                  <span>支付状态：</span>
                  未支付
                </div>
                <div v-if="scope.row.payState==='1'">
                  <span>支付状态：</span>
                  已支付
                </div>
                <div v-if="scope.row.payState==='2'">
                  <span>支付状态：</span>
                  支付失败
                </div>
              </div>
            </el-col>
          </el-row>
          <!-- <div class="carInfo">
          </div> -->
        </template>
      </el-table-column>
      <el-table-column label="状态"
                       header-align="left"
                       align="left"
                       min-width="107px">
        <template slot-scope="scope">
          <div class="statusInfo">
            <div v-if="scope.row.orderState === '0'">待运输</div>
            <div v-else-if="scope.row.orderState === '1'">运输中</div>
            <div v-else-if="scope.row.orderState === '2'">运输完成</div>
            <div v-else-if="scope.row.orderState === '3'">已取消</div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="carview_title">
      运输车辆列表
    </div>
    <el-form :inline="true"
             :model="formInline"
             class="carview_form">
      <el-form-item label="车辆运单号"
                    size="small">
        <el-input v-model="formInline.orderNum"
                  placeholder="请输入车辆运单号"></el-input>
      </el-form-item>
      <el-form-item label="车头号"
                    size="small">
        <el-input v-model="formInline.headNumber"
                  placeholder="请输入车头号"></el-input>
      </el-form-item>
      <el-form-item label="司机姓名"
                    size="small">
        <el-input v-model="formInline.driverName"
                  placeholder="请输入司机姓名"></el-input>
      </el-form-item>
      <el-button type="primary"
                 @click="onSubmit"
                 class="searchBtn">
        查询</el-button>
    </el-form>
    <div class="carview_table">
      <el-table style="width: 100%"
                height="100%"
                :data="driversList.list">
        <el-table-column prop="driverOrderNum"
                         header-align="center"
                         align="center"
                         label="车辆运单号">
        </el-table-column>
        <el-table-column header-align="center"
                         label="物流公司"
                         align="left">
          <template slot-scope="scope">
            <div>
              <span>公司名称：</span>
              {{scope.row.userCompanyName}}
            </div>
          </template>
        </el-table-column>
        <el-table-column header-align="center"
                         label="车辆信息"
                         align="left">
          <template slot-scope="scope">
            <div>
              <span>车头号：</span>
              {{scope.row.headNumber}}
            </div>
            <div>
              <span>车挂号：</span>
              {{scope.row.tailNumber}}
            </div>
            <div>
              <span>核载量：</span>
              {{scope.row.nuclearLoadTonnage}}吨
            </div>
            <div class="carviewlist">
              <span>罐体：</span>
              <div v-if="scope.row.materialTank === '01'">铝罐</div>
              <div v-else-if="scope.row.materialTank === '02'">铁罐</div>
              <div v-else-if="scope.row.materialTank === '03'">白钢罐</div>
              <div v-else-if="scope.row.materialTank === '04'">铝合金罐</div>
            </div>
            <div class="carviewlist">
              <span>状态：</span>
              <div v-if="scope.row.orderState === '0'">待运输</div>
              <div v-else-if="scope.row.orderState === '1'">运输中</div>
              <div v-else-if="scope.row.orderState === '2'">运输完成</div>
              <div v-else-if="scope.row.orderState === '3'">已取消</div>
            </div>
            <div class="craviewlist">
              <span>备案介质：</span>
              {{scope.row.mediumClass}}
            </div>
          </template>
        </el-table-column>
        <el-table-column header-align="center"
                         label="司机信息"
                         align="left">
          <template slot-scope="scope">
            <div>
              <span>姓名：</span>
              {{scope.row.dirverName}}
            </div>
            <div>
              <span>手机号：</span>
              {{scope.row.dirverPhone}}
            </div>
            <div>
              <div>身份证号：</div>
              {{scope.row.dirverIdCardNo}}
            </div>
          </template>
        </el-table-column>
        <el-table-column header-align="center"
                         label="装车量(吨)"
                         align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.orderState === '1'|scope.row.orderState === '2'">
              {{scope.row.loadCarNume}}
              <p @click="handleGetimg(0,scope.row.driverOrderId)"
                 class="loadimgBtn">
                查看图片
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column header-align="center"
                         label="卸车量(吨)"
                         align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.orderState === '2'">
              {{scope.row.unloadCarNume}}
              <p @click="handleGetimg(1,scope.row.driverOrderId)"
                 class="loadimgBtn">
                查看图片
              </p>
            </div>

          </template>
        </el-table-column>
        <el-table-column label="操作"
                         header-align="center"
                         align="center"
                         width="141">
          <template slot-scope="scope">
            <div class="statusInfo">
              <div v-if="scope.row.orderState === '0'"
                   @click="handleCancelClick(scope.row.driverOrderId)">取消运单</div>
              <div v-else-if="scope.row.orderState === '1' | scope.row.orderState === '2'"
                   @click="handleTrackClick(scope.row.driverOrderId)">查看轨迹</div>
              <div class="canceled"
                   v-else-if="scope.row.orderState === '3'">已取消</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="count">
      <span>总装车量(吨)：</span>
      {{driversList.totalloadCarNume}}
    </div>
    <div class="count">
      <span>总卸车量(吨)：</span>
      {{driversList.totalunloadCarNume}}
    </div>
    <el-dialog :title="titlename"
               :visible.sync="loadCar"
               class="loadCarImg">
      <el-carousel trigger="click"
                   arrow="always"
                   indicator-position='none'
                   :autoplay="false">
        <el-carousel-item v-for="(item,index) in imgList"
                          :key="index">
          <div class="imgMain">
            <img :src=item
                 alt="">
          </div>
          <div class="imgNums">{{index+1}}/{{imgList.length}}</div>
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
    <el-dialog title="运输轨迹"
               :visible.sync="track">
      <div class="container">
        <el-amap vid="amapDemo"
                 :center="center"
                 :amap-manager="amapManager"
                 :zoom="zoom"
                 class="amap-demo">
        </el-amap>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { waybillOrderView, waybillImages, waybillDriver, waybillCancel, waybillTrack } from 'apis/index'
import VueAMap from 'vue-amap'

let amapManager = new VueAMap.AMapManager()
export default {
  name: 'waybillDetail',
  data () {
    return {
      orderView: [],
      driversList: [],
      waybillNum: '',
      id: '',
      formInline: {
        orderNum: '',
        headNumber: '',
        driverName: ''
      },
      loadCar: false,
      track: false,
      imgList: [],
      titlename: '',
      trajectory: {},
      zoom: 6,
      center: [116.3802337646, 39.8631078118],
      amapManager
    }
  },
  methods: {
    getCompanyOrderList (id) { // 获取公司运单
      waybillOrderView({
        companyOrderId: id
      }).then(res => {
        if (res.data.code === 0) {
          this.waybillNum = res.data.data.result.orderNum

          this.orderView.push(res.data.data.result)
          console.log('aaa', this.orderView)
        }
      })
    },
    getDriverList (id) { // 初始化页面，获取运单详情
      waybillDriver({
        companyOrderId: id
      }).then(res => {
        if (res.data.code === 0) {
          this.driversList = res.data.data
          console.log('asasas', this.driversList)
        }
      })
    },
    onSubmit () { // 运输车辆列表查询
      waybillDriver({
        companyOrderId: this.id,
        driverOrderNum: this.formInline.orderNum,
        headNumber: this.formInline.headNumber,
        dirverName: this.formInline.driverName
      }).then(res => {
        if (res.data.code === 0) {
          this.driversList = res.data.data
        }
      })
    },
    handleGetimg (item, driverOrderId) { // 获取图片
      if (item === 0) {
        this.titlename = '装车量'
      } else if (item === 1) {
        this.titlename = '卸车量'
      }
      // console.log('aaaa', driverOrderId)
      this.imgList = []
      waybillImages({
        driverOrderId: driverOrderId,
        type: item
      }).then(res => {
        if (res.data.code === 0) {
          // console.log('sss', res)
          this.imgList = res.data.data.list
          if (this.imgList.length) {
            this.loadCar = true
          } else {
            this.$alert('暂无图片', {
              confirmButtonText: '确定'
            })
          }
        }
      })
    },
    handleCancelClick (id) { // 取消运单
      this.$confirm('确认取消运单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        waybillCancel({
          driverOrderId: id
        }).then(res => {
          if (res.data.code === 0) {
            this.getDriverList(this.id)
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleTrackClick (id) { // 查看运单轨迹
      this.track = true
      waybillTrack({
        driverOrderId: id
      }).then(res => {
        if (res.data.code === 0) {
          this.trajectory = res.data.data
          let trackList = []
          for (var i = 0; i < this.trajectory.list.length; i++) {
            let list = this.trajectory.list[i].split(',').reverse()

            trackList.push(list)
          }
          // console.log('1111', trackList)

          let sMap = amapManager.getMap()
          sMap.clearMap()
          // 将当前车辆位置坐标点定位为地图中心点
          let center = trackList[trackList.length - 1]
          let centerIcon = new AMap.Icon({
            image: ''
          })
          this.remarkPoint(center, centerIcon)

          // 出发地坐标点
          let startPoint = []
          startPoint = this.trajectory.destinaLatLng.split(',').reverse()
          let srtatIcon = new AMap.Icon({
            image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
            imageSize: new AMap.Size(135, 40),
            imageOffset: new AMap.Pixel(-9, 0)
          })
          this.remarkPoint(startPoint, srtatIcon)

          // 目的地坐标点
          let endPoint = []
          let endIcon = new AMap.Icon({
            image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
            imageSize: new AMap.Size(135, 40),
            imageOffset: new AMap.Pixel(-95, -3)
          })
          endPoint = this.trajectory.departLatLng.split(',').reverse()
          this.remarkPoint(endPoint, endIcon)

          // 创建一个 icon
          let remark = new AMap.Marker({
            position: center,
            icon: 'http://image.jsh178.com/FmQdHrf-kE2vPHc4AxAH1xHFl0qI',
            offset: new AMap.Pixel(-26, -13),
            autoRotation: true,
            angle: -90
          })
          // 绘制轨迹
          let polyline = new AMap.Polyline({
            map: sMap,
            path: trackList,
            showDir: false,
            strokeColor: '#1b88ee', // 线颜色
            // strokeOpacity: 1,     //线透明度
            strokeWeight: 6 // 线宽
            // strokeStyle: "solid"  //线样式
          })
          let passedPolyline = new AMap.Polyline({
            map: sMap,
            // path: trackList,
            strokeColor: '#1b88ee', // 线颜色
            // strokeOpacity: 1,     //线透明度
            strokeWeight: 6 // 线宽
            // strokeStyle: "solid"  //线样式
          })
          remark.on('moving', function (e) {
            passedPolyline.setPath(e.passedPath)
          })
          sMap.setFitView()
          remark.moveAlong(trackList, 9999999)
          remark.setMap(sMap)
        }
      })
    },
    remarkPoint (item, icon, center) {
      let o = amapManager.getMap()
      // 创建一个 icon
      let remark = new AMap.Marker({
        size: new AMap.Size(25, 34),
        position: item,
        icon: icon,
        zoom: 6,
        center: center
      })
      remark.setMap(o)
    }

  },
  mounted () {
    this.id = this.$route.query.item
    this.getCompanyOrderList(this.id)
    this.getDriverList(this.id)
  }

}

</script>
<style lang="stylus">
@import '~styles/mixins.styl'
.waybillDetail
  background #f7f9fb
  padding 0 20px
  font-size 12px
  overflow-y auto
  min-width 818px
  .title
    height 50px
    line-height 50px
    font-size 12px
    color #858C96
    background url('../../../assets/images/01/nav_arrow.png') no-repeat top 21px left 80px #F7F9FB
    span
      color #212832
      margin-left 20px
  .orderview_title
    width calc(100% - 46px)
    line-height 46px
    border-bottom 1px solid #eee
    padding-left 46px
    background url('../../../assets/images/02/yundan_icon.png') no-repeat center left 14px #fff
    span
      float right
      margin-right 20px
  .order_table
    border-bottom 1px solid #ccc
    border-top 1px solid #ccc
    th
      background #e7f0f8
      border-bottom 1px solid #ccc
      .cell
        size12()
        padding-left 40px
    td
      size12()
      .sourceInfo, .logistics
        width 40%
        float left
        margin-left 30px
        color #5E656F
        .orderList
          div
            color #858C96
          span
            color #858C96
          p
            display inline
      .carInfo
        width 60%
        margin-left 10px
        float left
        background #000
        div
          color #5E656F
          span
            color #858C96
      .serviceInfo
        width 40%
        float left
        background #f66
      .statusInfo
        margin-left 30px
        color #1B88EE
    td.order_car
      border-left 1px solid #ccc
      border-right 1px solid #ccc
  .el-table td, .el-table th
    vertical-align top
  .carview_title
    width calc(100% - 46px)
    line-height 46px
    border-bottom 1px solid #eee
    padding-left 46px
    margin-top 20px
    background url('../../../assets/images/02/yunshu_icon.png') no-repeat center left 14px #fff
    // height 300px
  .carview_form
    background #fff
    padding-left 14px
    .searchBtn
      // padding 6px 24px
      margin-top 9px
      float right
      margin-right 20px
      searchBtn()
    .el-form-item
      margin-bottom 6px
      margin-top 6px
  .carview_table
    height 328px
    th
      background #e7f0f8
      .cell
        size12()
    td
      size12()
      .loadimgBtn
        color #1B88EE
        text-decoration underline
        cursor pointer
      .statusInfo
        div
          margin 0 auto
          width 78px
          height 28px
          line-height 28px
          background #1B88EE
          border-radius 3px
          color #fff
          cursor pointer
        .canceled
          background #CFD5DC
          cursor auto
          border-radius 3px
      .carviewlist
        div
          display inline
  .count
    text-align right
    font-size 16px
    color #212832
    line-height 30px
    span
      color #5E656F
      font-size 13px
      font-weight 600
  .el-dialog
    width 90vw
    height 90%
    margin-top 2vw !important
    .el-dialog__header
      height 42px
      padding 0 20px 0
      text-align left
      background #1b88ee
      line-height 42px
      .el-dialog__title
        font-size 13px
        color #fff
    .el-dialog__headerbtn
      top 12px
      right 12px
      .el-dialog__close
        color #fff
        font-size 20px
    .el-dialog__body
      height calc(100% - 62px)
      padding 12px
      .el-carousel
        width 100%
        height 100%
        .el-carousel__container
          width 100%
          // background #f66
          height 100% !important
          margin 0 auto
        .el-carousel__arrow--left
          left 0px
          width 21px
          height 38px
          background url('../../../assets/images/02/left_n_page.png') no-repeat
          &:hover
            background url('../../../assets/images/02/left_h_page.png') no-repeat
        .el-icon-arrow-right:before
          content '' !important
        .el-carousel__arrow--right
          right 0px
          width 21px
          height 38px
          background url('../../../assets/images/02/righe_n_page.png') no-repeat
          &:hover
            background url('../../../assets/images/02/right_h_page.png') no-repeat
        .el-icon-arrow-left:before
          content '' !important
        .imgMain
          width 100%
          height 100%
          // background #0f0
          position relative
          // top 50%
          // left 50%
          // transform translate(-50%,-50%)
          img
            height 100%
            position absolute
            top 50%
            left 50%
            transform translate(-50%, -50%)
        .imgNums
          position absolute
          bottom 10px
          left 50%
          transform translatex(-50%)
    .container
      width 100%
      height 100%
      .amap-demo
        width 100%
        height 100%
</style>
